var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgUndo(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8 20H15C18.3158 20 21 17.3158 21 14C21 10.6842 18.3158 8 15 8H4C3.4386 8 3 8.4386 3 9C3 9.5614 3.4386 10 4 10H15C17.3333 10 19 11.6667 19 14C19 16.3333 17.3333 18 15 18H8C7.4386 18 7 18.4386 7 19C7 19.5614 7.4386 20 8 20ZM7.29825 4.29825L3.29825 8.29824C3.10526 8.47368 3 8.7193 3 9C3 9.5614 3.4386 10 4 10C4.2807 10 4.52632 9.89474 4.70175 9.70175L8.70175 5.70175C8.89474 5.52632 9 5.2807 9 5C9 4.4386 8.5614 4 8 4C7.7193 4 7.47368 4.10526 7.29825 4.29825ZM3.29825 9.70175L7.29825 13.7018C7.47368 13.8947 7.7193 14 8 14C8.5614 14 9 13.5614 9 13C9 12.7193 8.89474 12.4737 8.70175 12.2982L4.70175 8.29824C4.52632 8.10526 4.2807 8 4 8C3.4386 8 3 8.4386 3 9C3 9.2807 3.10526 9.52632 3.29825 9.70175Z",
    fill: "currentColor"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUndo);
export default __webpack_public_path__ + "static/media/undo.25268a1f.svg";
export { ForwardRef as ReactComponent };